const configAggregator = (node) => {
    return {
        minHeight: node.getAttribute('data-min-height'),
        autoplay: node.getAttribute('data-autoplay') === 'true',
        autoplaySpeed: parseInt(node.getAttribute('data-autoplay-speed')),
        infinite: node.getAttribute('data-infinite-loop') === 'true',
        showArrows: node.getAttribute('data-show-arrows') === 'true',
        showDots: node.getAttribute('data-show-dots') === 'true',
        showEdgesOfAdjacentSlide:
            node.getAttribute('data-show-edges-of-adjacent-slide') === 'true' ||
            false
    }
}
export default configAggregator
